"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.articlesFromCollectionErrorSelector = exports.articlesFromCollectionHasMoreSelector = exports.articlesFromCollectionIsLoadingSelector = exports.articlesFromCollectionMetadataSelector = exports.articlesFromCollectionDataSelector = exports.articlesListErrorSelector = exports.articlesListHasMoreSelector = exports.articlesListMetadataSelector = exports.articlesListHighlightedSelector = exports.articlesListIsLoadingSelector = exports.articlesListDataSelector = void 0;

var _reselect = require("reselect");

var articlesSelector = function articlesSelector(state) {
  return state.articles;
};

var articlesListSelector = (0, _reselect.createSelector)(articlesSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.articles;
});
var articlesListDataSelector = (0, _reselect.createSelector)(articlesListSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.data;
});
exports.articlesListDataSelector = articlesListDataSelector;
var articlesListIsLoadingSelector = (0, _reselect.createSelector)(articlesListSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.isLoading;
});
exports.articlesListIsLoadingSelector = articlesListIsLoadingSelector;
var articlesListHighlightedSelector = (0, _reselect.createSelector)(articlesListSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.highlighted;
});
exports.articlesListHighlightedSelector = articlesListHighlightedSelector;
var articlesListMetadataSelector = (0, _reselect.createSelector)(articlesListSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.meta;
});
exports.articlesListMetadataSelector = articlesListMetadataSelector;
var articlesListHasMoreSelector = (0, _reselect.createSelector)(articlesListMetadataSelector, function (articlesListMetadata) {
  return articlesListMetadata === null || articlesListMetadata === void 0 ? void 0 : articlesListMetadata.hasNext;
});
exports.articlesListHasMoreSelector = articlesListHasMoreSelector;
var articlesListErrorSelector = (0, _reselect.createSelector)(articlesListSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.error;
});
exports.articlesListErrorSelector = articlesListErrorSelector;
var articlesFromCollectionSelector = (0, _reselect.createSelector)(articlesSelector, function (articles) {
  return articles === null || articles === void 0 ? void 0 : articles.articlesFromCollection;
});
var articlesFromCollectionDataSelector = (0, _reselect.createSelector)(articlesFromCollectionSelector, function (articlesFromCollection) {
  return articlesFromCollection === null || articlesFromCollection === void 0 ? void 0 : articlesFromCollection.data;
});
exports.articlesFromCollectionDataSelector = articlesFromCollectionDataSelector;
var articlesFromCollectionMetadataSelector = (0, _reselect.createSelector)(articlesFromCollectionSelector, function (articlesFromCollection) {
  return articlesFromCollection === null || articlesFromCollection === void 0 ? void 0 : articlesFromCollection.meta;
});
exports.articlesFromCollectionMetadataSelector = articlesFromCollectionMetadataSelector;
var articlesFromCollectionIsLoadingSelector = (0, _reselect.createSelector)(articlesFromCollectionSelector, function (articlesFromCollection) {
  return articlesFromCollection === null || articlesFromCollection === void 0 ? void 0 : articlesFromCollection.isLoading;
});
exports.articlesFromCollectionIsLoadingSelector = articlesFromCollectionIsLoadingSelector;
var articlesFromCollectionHasMoreSelector = (0, _reselect.createSelector)(articlesFromCollectionMetadataSelector, function (articlesFromCollectionMeta) {
  return articlesFromCollectionMeta === null || articlesFromCollectionMeta === void 0 ? void 0 : articlesFromCollectionMeta.hasNext;
});
exports.articlesFromCollectionHasMoreSelector = articlesFromCollectionHasMoreSelector;
var articlesFromCollectionErrorSelector = (0, _reselect.createSelector)(articlesFromCollectionSelector, function (articlesFromCollection) {
  return articlesFromCollection === null || articlesFromCollection === void 0 ? void 0 : articlesFromCollection.error;
});
exports.articlesFromCollectionErrorSelector = articlesFromCollectionErrorSelector;
var _default = {
  articlesListDataSelector: articlesListDataSelector,
  articlesListIsLoadingSelector: articlesListIsLoadingSelector,
  articlesListHighlightedSelector: articlesListHighlightedSelector,
  articlesListHasMoreSelector: articlesListHasMoreSelector,
  articlesListErrorSelector: articlesListErrorSelector,
  articlesFromCollectionDataSelector: articlesFromCollectionDataSelector,
  articlesFromCollectionMetadataSelector: articlesFromCollectionMetadataSelector,
  articlesFromCollectionHasMoreSelector: articlesFromCollectionHasMoreSelector,
  articlesFromCollectionIsLoadingSelector: articlesFromCollectionIsLoadingSelector,
  articlesFromCollectionErrorSelector: articlesFromCollectionErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map